import { WhatsAppAppointmentButton } from './WhatsAppAppointmentButton'

interface CTASectionProps {
  title?: string;
  description?: string;
  buttonText?: string;
}

export function CTASection({ 
  title,
  description,
  buttonText
}: CTASectionProps) {
  // Use default values from i18n if not provided
  const defaultTitle = "¿Listo para dar el primer paso?";
  const defaultDescription = "Contáctanos hoy mismo para agendar una evaluación inicial y descubrir cómo podemos ayudar a tu hijo a alcanzar su máximo potencial.";
  const defaultButtonText = "Agenda una Cita";
  
  const finalTitle = title || defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalButtonText = buttonText || defaultButtonText;
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-neuro-green z-0"></div>
      {/* Círculos decorativos más visibles */}
      <div className="absolute -top-10 right-10 w-40 h-40 bg-white opacity-20 rounded-full hidden md:block"></div>
      <div className="absolute -bottom-10 left-10 w-40 h-40 bg-white opacity-20 rounded-full hidden md:block"></div>
      <div className="absolute bottom-20 right-20 w-30 h-30 bg-neuro-yellow opacity-30 rounded-full hidden md:block"></div>
      <div className="absolute top-20 left-20 w-24 h-24 bg-neuro-blue opacity-30 rounded-full hidden md:block"></div>
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-12 max-w-4xl mx-auto transform transition-all duration-500 hover:scale-[1.02]">
          <h2 className="text-4xl font-bold text-neuro-dark-blue mb-6">{finalTitle}</h2>
          <p className="text-xl text-neuro-dark-blue mb-10 max-w-2xl mx-auto">
            {finalDescription}
          </p>
          <WhatsAppAppointmentButton
            className="bg-neuro-green text-neuro-dark-blue font-bold py-5 px-12 hover:bg-green-500 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-lg"
            message="Hola, me interesa agendar una cita para mi hijo en Neuro Peques. ¿Podrían brindarme información sobre disponibilidad y el proceso de evaluación inicial?"
          >
            {finalButtonText}
          </WhatsAppAppointmentButton>
        </div>
      </div>
    </section>
  )
}
